import { render, staticRenderFns } from "./fault.vue?vue&type=template&id=0b1de0fd&"
import script from "./fault.vue?vue&type=script&lang=js&"
export * from "./fault.vue?vue&type=script&lang=js&"
import style0 from "./fault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports